/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserForOrganizationSitesAdminRequest } from '../../models/user-for-organization-sites-admin-request';

export interface PostAdministrationOrganizationSitesUser$Params {
      body: UserForOrganizationSitesAdminRequest
}

export function postAdministrationOrganizationSitesUser(http: HttpClient, rootUrl: string, params: PostAdministrationOrganizationSitesUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postAdministrationOrganizationSitesUser.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postAdministrationOrganizationSitesUser.PATH = '/administration/organization-sites/users';
